module.exports = __webpack_public_path__ + "img/202402_02.9f8e8b85.jpg";